import { render, staticRenderFns } from "./bpp.vue?vue&type=template&id=aa303f8c"
import script from "./bpp.vue?vue&type=script&lang=js"
export * from "./bpp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports